import React, { useState } from "react";
import Footer from "../components/footer";
import Signin from "../components/signin";
import NavbarComponent from "../components/navbar/index";
import { Sidebar } from "./../components/sidebar";

const SigninPage = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="d-flex flex-column min-vh-100">
    <Sidebar isOpen={isOpen} toggle={toggle} />
  
    <main className="flex-grow-1">
      <Signin />
    </main>
  
    <Footer />
  </div>
  
  );
};

export default SigninPage;
